import type { SocialPostImageQaSummary, SocialPostImageQaSummaryEvent } from "./types";

type ImageQaFailurePolicy = SocialPostImageQaSummaryEvent["failurePolicy"];
type ImageQaEventStatus = SocialPostImageQaSummaryEvent["selectionStatus"];
type ImageQaTaskKind = SocialPostImageQaSummaryEvent["taskKind"];

export const getImageQaFailurePolicyLabel = (policy: ImageQaFailurePolicy): string => {
  switch (policy) {
    case "select_best":
      return "Select best";
    case "fail_task":
      return "Fail task";
  }
};

export const getImageQaStatusLabel = (status: ImageQaEventStatus): string => {
  switch (status) {
    case "qa_passed":
      return "QA passed";
    case "qa_failed_selected_best":
      return "Selected best after QA failed";
    case "qa_unavailable_selected_best":
      return "Selected best because QA was unavailable";
    case "qa_disabled":
      return "QA disabled";
    case "task_failed":
      return "Task failed";
  }
};

export const getImageQaTaskKindLabel = (kind: ImageQaTaskKind): string => {
  switch (kind) {
    case "social_post":
      return "Generation";
    case "social_post_image_regeneration":
      return "Regeneration";
  }
};

export const formatImageQaBlockLabel = (event: SocialPostImageQaSummaryEvent): string => {
  if (!event.blockId) {
    return "Task-level";
  }

  if (!event.carouselSlide) {
    return event.blockId;
  }

  return `Slide ${event.carouselSlide.index} · ${event.carouselSlide.role} · ${event.blockId}`;
};

export const formatImageQaRetryCount = (retryCount: number | null): string => {
  if (retryCount === null) {
    return "n/a";
  }

  if (retryCount === 0) {
    return "No retry";
  }

  return retryCount === 1 ? "1 retry" : `${retryCount} retries`;
};

export const formatImageQaScore = (scorePct: number | null): string =>
  scorePct === null ? "--" : `${scorePct}%`;

export const formatImageQaPassRate = (summary: SocialPostImageQaSummary): string => {
  if (summary.totals.evaluationCount === 0) {
    return "--";
  }

  return `${Math.round((summary.totals.passedCount / summary.totals.evaluationCount) * 100)}%`;
};
